﻿import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListKostenart extends GuiListGeneric {

    constructor() {
        super("Kostenart");

    }

}



